$(document).foundation();

$.fn.isInViewport = function (tolerance=0) {
  let elementTop = $(this).offset().top;
  let elementBottom = elementTop + $(this).outerHeight();

  let viewportTop = $(window).scrollTop() - tolerance;
  let viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

(function ($) {

  // on scroll change header class
  if ($('header.scroll-change').length > 0) {
    $(window).on('scroll', function() {
      if ($(window).scrollTop() > $(window).height() / 3) {
        $('header').removeClass('transparent');
      } else {
        $('header').addClass('transparent');
      }
    });
  }

  // hover submenu
  $(".header-menu .page-nav").on("mouseenter", function() {
    var $pageNav = $(this).closest('.page-nav');
    var $subNavigation = $pageNav.find('.page-subnav-container');
    if ($subNavigation.length > 0) {
      // jquery cannot compute hidden element's position and dimension, so there it is
      $subNavigation.css({'opacity': 0}).show();
      var subNavRight = $pageNav.offset().left + $subNavigation.outerWidth();
      $subNavigation.hide().css({'opacity': 1});
      var windowRight = $(document).width();
      console.log(subNavRight, windowRight);
      if (subNavRight > windowRight) {
        $subNavigation.css({
          'left': (subNavRight - windowRight) * -1,
        });
      } else {
        $subNavigation.css({
          'left': 0,
        })
      }
      $subNavigation.fadeIn(250);
    }
  })
  .on("mouseleave", function() {
    var $pageNav = $(this).closest('.page-nav');
    var $subNavigation = $pageNav.find('.page-subnav-container');
    if ($subNavigation.length > 0) {
      $subNavigation.fadeOut(250);
    }
  });

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  });

  // add icon to external link, also target blank
  $(".layout-textual .text-content a, .layout-title-columns .bottom-section a, .single-post #post-content a").each(function() {
    if (!$(this).hasClass('button-link') && !$(this).hasClass('button')) {
      if (this.hostname && this.hostname != location.hostname) {
        $('<span class="external fal fa-external-link"></span>').insertAfter($(this));
        $(this).attr('target','_blank');
      }  
    }
  });

  // image scroll reveal/fade
  $(".image-scroll-reveal .image-content").addClass('scroll-reveal');
  if ($(".scroll-reveal").length > 0) {
    $(window).on("scroll", function() {
      $(".scroll-reveal").each(function() {
        var tolerance = 0;
        var $image = $(this);
        if ($image.parents('.image-scroll-reveal').data('scroll-reveal-tolerance')) {
          tolerance = parseInt($image.parents('.image-scroll-reveal').data('scroll-reveal-tolerance'));
        }
        if ($(this).isInViewport(tolerance)) {
          $(this).addClass('revealed');
        }
      });
    });
    $(window).trigger('scroll');
  }


  // video popup dimension - keep 16:9
  function proportionalizeVideoEmbed() {
    var $embedIframe = $(".video-embed-play iframe");
    $embedIframe.height(9.0/16.0 * $embedIframe.outerWidth());
  }
  var viewEmbedResizeTimer = null;
  $(window).on('resize', function() {
    if (!viewEmbedResizeTimer) {
      setTimeout(function() {
        proportionalizeVideoEmbed();
      }, 250);
    }
  }).trigger("resize");
  $(".reveal.video-embed-play").on("open.zf.reveal", function() {
    proportionalizeVideoEmbed();
  });

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

})(jQuery);
